<template>
  <div
    v-show="false"
    class="flex relative flex-row h-[74px] mb-4 opacity-60 hover:opacity-100 transition-bg ease-in-out duration-1000 rounded-full border-transparent"
    :class="[
      { '!h-[350px] !opacity-100 shadow-lg shadow-[#841FF460] ': menu_open },
      { 'bg-gradient-to-b from-[#2DA7D7]  to-[#841FF4]': show_border }
    ]">
    <div
      :class="[{ '!bg-transparent': !show_border }]"
      class="bg-white rounded-full w-[91%] ml-[4.5%] mt-[6%] mb-[5%] items-center justify-center flex">
      <div
        :class="[{ 'hover:shadow-lg hover:shadow-[#841FF460]': !show_border }]"
        class="w-16 transition-all ease-in-out h-14 mt-auto flex items-center justify-center bg-gradient-to-b from-[#2DA7D7] to-[#841FF4] m-1 rounded-full"
        @click="handleOpenMenuClick">
        <div class="absolute cursor-pointer">
          <AIMenuIcon />
        </div>
      </div>
      <div :class="[{ 'pointer-events-none ': !active_item }]" class="absolute bottom-20">
        <div
          :style="{ top: `${3 + menu_items.findIndex((item) => item.value == active_item) * 50}px` }"
          :class="[{ 'opacity-100': menu_items.length == show_menu_icons }, { 'duration-0': !menu_open }]"
          class="w-11 left-0.5 h-11 opacity-0 bg-gray-300/25 absolute rounded-lg transition-all ease-in-out duration-500" />

        <div
          v-for="(menu_item, index) in menu_items"
          :key="menu_item.value"
          :class="[{ '!opacity-100': show_menu_icons >= menu_items.length - index + 1 - 1 }]"
          class="opacity-0 transition ease-in-out mb-1 p-3 rounded-lg cursor-pointer relative"
          @click="active_item = menu_item.value"
          @mouseenter="menu_hovered = index"
          @mouseleave="menu_hovered = null">
          <component
            :is="menu_item.icon"
            class="transition ease-in-out"
            :color_1="menu_hovered == index || active_item == menu_item.value ? '#2DA7D7' : null"
            :color_2="menu_hovered == index || active_item == menu_item.value ? '#841FF4' : null"
            :class="[]" />
          <span class="absolute right-1 top-1 bg-gradient-to-b from-[#2DA7D7] to-[#841FF4] w-2 h-2 rounded-full" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AIChatbotIcon from "@/components/shared/icons/AIChatbotIcon"
import AIStarIcon from "@/components/shared/icons/AIStarIcon"
import AISuggestionsIcon from "@/components/shared/icons/AISuggestionsIcon"
import AISettingsIcon from "@/components/shared/icons/AISettingsIcon"
import AIBellIcon from "@/components/shared/icons/AIBellIcon"
import AIMenuIcon from "@/components/shared/icons/AIMenuIcon"

export default {
  components: { AIChatbotIcon, AIStarIcon, AISuggestionsIcon, AISettingsIcon, AIBellIcon, AIMenuIcon },
  props: {},
  emits: ["update:selectedItem"],
  data() {
    return {
      menu_open: false,
      show_menu_icons: 0,
      show_border: false,
      menu_hovered: null,
      active_item: null
    }
  },

  computed: {
    menu_items() {
      return [
        { icon: "AIChatbotIcon", value: "chatbot" },
        { icon: "AIChatbotIcon", value: "onboarding" },
        { icon: "AIStarIcon", value: "goals" },
        { icon: "AISuggestionsIcon", value: "suggestions" },
        { icon: "AISettingsIcon", value: "settings" },
        { icon: "AIBellIcon", value: "notifications" }
      ]
    }
  },
  watch: {
    active_item() {
      this.$emit("update:selectedItem", this.active_item)
    }
  },

  created() {},

  methods: {
    handleOpenMenuClick() {
      if (this.menu_open) {
        this.menu_items.forEach((_, i) => {
          setTimeout(() => {
            this.show_menu_icons -= 1
          }, 100 * i)
        })
        setTimeout(() => {
          this.show_border = false
        }, 1000)
        this.active_item = null
      } else {
        this.show_border = true
        this.show_menu_icons = 0
        this.menu_items.forEach((_, i) => {
          setTimeout(
            () => {
              this.show_menu_icons += 1
            },
            800 + 100 * i
          )
        })
        setTimeout(() => {
          if (!this.active_item) {
            this.active_item = this.menu_items[0].value
          }
        }, 1000)
      }
      this.menu_open = !this.menu_open
    }
  }
}
</script>
